var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bottom"},[_c('div',[_vm._v("© univteam.com 2011 - 2031")]),_c('div',[_vm._v("天才在线（北京）科技有限公司 ")]),_c('div',{on:{"click":_vm.toBeian}},[_vm._v("京ICP备12024124号-9")])])}
var staticRenderFns = []

export { render, staticRenderFns }